module.exports = __webpack_public_path__ + "img/die-mobiliar.d2be226.png";